module.exports = __webpack_public_path__ + "static/media/PATS_5-1920w.37dd77e9.png";